import {Attendee} from 'Event/attendee'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'

export interface ActiveCampaignTag {
  tag: string
  id: number
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/active_campaign/add_tag`)
  return (tag: ActiveCampaignTag) => {
    try {
      client.post(url, {
        id: tag.id,
      })
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/active_campaign/test_tag`)
  return async (tag: ActiveCampaignTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      id: tag.id,
      attendee_id: attendee.id,
    })
  }
}
